"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const getNumberFromUnknown_1 = __importDefault(require("./getNumberFromUnknown"));
const getValueByPathFromUnknown = (value, path) => {
    if (path.length < 1) {
        return value;
    }
    const [link, ...restOfPath] = path;
    if ((0, valueIsArray_1.default)(value) || (0, valueIsString_1.default)(value)) {
        if (link === 'length') {
            return value.length;
        }
        try {
            const index = (0, getNumberFromUnknown_1.default)(link);
            return getValueByPathFromUnknown(value[index], restOfPath);
        }
        catch (_a) {
            return undefined;
        }
    }
    if (!(0, valueIsRecord_1.default)(value)) {
        return undefined;
    }
    return getValueByPathFromUnknown(value[link], restOfPath);
};
exports.default = getValueByPathFromUnknown;
